import {t} from 'i18next';
import PropTypes from 'prop-types';
import React from 'react';
import {withTranslation} from 'react-i18next';
import BaseListContainer from '../../../baseContainers/BaseListContainer';
import ActionLink from '../../../components/ActionLink';
import AppPrefixUtils from '../../../utils/AppPrefixUtils';
import AuthService from '../../../services/AuthService';
import CriteriaCalendarRangeComponent from '../../../components/criteria/CriteriaCalendarRangeComponent';
import VoucherService from '../../../services/VoucherService';
import Constants from '../../../utils/constants';
import CriteriaTextComponent from '../../../components/criteria/CriteriaTextComponent';
import {withRouter} from 'react-router-dom/cjs/react-router-dom.min';
import { Button, Menu } from 'primereact';

class VoucherListContainer extends BaseListContainer {
    constructor(props) {
        super(props, new VoucherService());
        this.state = {
            list: [],
            loading: true,
            criteria: this.getCleanSearchCriteria(),
        };
        this.authService = new AuthService();
    }

    updateSearchCriteria(criteria) {
        return {
            name: criteria.name,
            locale: criteria.locale,
            dateFrom: criteria.dateFrom,
            dateTo: criteria.dateTo,
            firstResult: criteria.firstResult,
            maxResults: criteria.maxResults,
            sortField: criteria.sortField,
            sortAsc: criteria.sortAsc,
            voucherCategoryName: criteria.voucherCategoryName,
        };
    }

    getCleanSearchCriteria() {
        return {
            name: '',
            locale: this.authService.getI18n(),
            dateFrom: undefined,
            dateTo: undefined,
            firstResult: 0,
            maxResults: 10,
            sortField: 'id',
            sortAsc: true,
            voucherCategoryName: '',
        };
    }
    getDataKey() {
        return 'id';
    }
    getListTitle() {
        return 'voucher.listTitle';
    }
    getCriteriaName() {
        return 'voucher-list-sc';
    }

    getContainerListName() {
        return 'voucher-list-container';
    }

    renderCriteria() {
        return (
            <div>
            <div className='row'>
                <CriteriaTextComponent
                    id='name-sc'
                    name='voucherCategoryName'
                    label={t('voucher.nameCategory')}
                    colClass='col-lg-4 col-sm-6'
                    value={this.state.criteria.voucherCategoryName}
                    onChange={this.handleChangeSc}
                    validator={this.validator}
                />
                </div>
                <div class="row">
                <CriteriaCalendarRangeComponent
                    id='date-sc'
                    idFrom='dateFrom-sc'
                    idTo='dateTo-sc'
                    name='date'
                    nameFrom='dateFrom'
                    nameTo='dateTo'
                    colClass='col-sm-12 col-md-8 col-lg-6 col-xl-4'
                    from={this.state.criteria.dateFrom}
                    to={this.state.criteria.dateTo}
                    onChange={this.handleChangeSc}
                    validator={this.validator}
                    refreshFromBackend
                    showButtonBar
                    sharedLabel
                    maxDateInfinite
                    placeholderFrom={t('voucher.dateFrom')}
                    placeholderTo={t('voucher.dateTo')}
                    inputsClassName='col-6'
                />
            </div>
            </div>
        );
    }

    prepareHeaderItems() {
        const {t, newUrl} = this.props;
        const href = `${newUrl}/`+sessionStorage.getItem('i18nextLng');
        return this.authService.isUserInAnyRole('ROLE_ADMINISTRATOR', 'ROLE_CONTENT_CREATOR')
            ? [
                  {
                      label: t('voucher.addButton'),
                      onClick: () => {
                          //   window.location.href = AppPrefixUtils.locationHrefUrl(href);
                          this.props.history.push(AppPrefixUtils.locationHrefUrl(href));
                      },
                      type: 'BUTTON',
                      className: 'float-left',
                      variant: 'white',
                      iconName: 'mdi-plus',
                      iconSide: 'left',
                  },
              ]
            : [];
    }

    prepareColumns() {
        return [
            {
                field: 'id',
                header: t('ID'),
                sortable: true,
            },
            {
                field: 'status',
                header: t('voucher.status'),
                sortable: true,
            },
            {
                field: 'title',
                header: t('voucher.title'),
                sortable: true,
            },
            {
                field: 'dateFrom',
                header: t('voucher.dateFrom'),
                body: this.dateTemplate.bind(this, 'dateFrom', Constants.DATE_TIME_FORMAT),
                sortable: true,
            },
            {
                field: 'dateTo',
                header: t('voucher.dateTo'),
                body: this.dateTemplate.bind(this, 'dateTo', Constants.DATE_TIME_FORMAT),
                sortable: true,
            },
            {
                field: 'cost',
                header: t('voucher.cost'),
                sortable: true,
            },
            {
                field: 'voucherCategoryName',
                header: t('voucher.category'),
                sortable: true,
            },
            // {
            //     field: 'partnerName',
            //     header: t('voucher.partner'),
            //     sortable: false,
            // },
            {
                key: 'actions',
                header: t('global.action'),
                body: this.actionTemplate,
                className: 'table-column-action',
            },
        ];
    }

    translate(key) {
        const {t} = this.props;
        return t(key);
    }
    actionTemplate(rowData) {
       const menuRef = React.createRef();
        const { detailUrl } = this.props;
        const detailHref = `${detailUrl}/${rowData?.id}/` + sessionStorage.getItem('i18nextLng');
    
        const menuItems = [
            {
                label: t('global.edit'),
                icon: 'pi pi-pencil',
                command: () => this.handleGoToDetail(detailHref),
            }
        ];
    
        return (
            <div>
                <Menu model={menuItems} popup ref={menuRef} />
                <Button
                    icon="pi pi-ellipsis-v"
                    className="menu-items"
                    onClick={(event) => menuRef.current.toggle(event)}
                />
            </div>
        );
    }


    breadCrumbItems() {
        return [{name: t('voucher.listTitle'), url: '/voucher-list'}];
    }
    render() {
        return <div className='container-fluid'>{this.renderView()}</div>;
    }
}

VoucherListContainer.defaultProps = {
    detailUrl: '/voucher/details',
    newUrl: '/voucher/create',
    editUrl: '/voucher/edit',
    lazy: true,
};

VoucherListContainer.propTypes = {
    detailUrl: PropTypes.string,
    newUrl: PropTypes.string,
};

export default withRouter(withTranslation()(VoucherListContainer));
